<template>
  <transition name="fade">
    <div v-if="displayToast" class="toast" :class="type">
      <div class="toast-header">
        <button class="close" @click="onClickClose"><span aria-hidden="true">&times;</span></button>
      </div>
      <div class="toast-body">
        {{ message }}
      </div>
    </div>
  </transition>
</template>

<script lang="ts">
import { defineComponent, onUpdated, ref } from 'vue';
export default defineComponent({
  name: 'Toast',
  props: {
    show: Boolean,
    message: String,
    type: String, // availble options: success, error, warning
  },
  emits: ['close'],
  setup(props, { emit }) {
    const displayToast = ref<boolean>(false);
    // timer for success toast, only stays for 5s
    let timer: number;
    const timerDelay = 5000;

    const onClickClose = () => {
      displayToast.value = false;
      emit('close');
    };

    const updateDisplayToast = () => {
      if (props.show) {
        displayToast.value = true;

        if (props.type === 'success') {
          clearTimeout(timer);
          timer = setTimeout(() => {
            displayToast.value = false;
            emit('close');
          }, timerDelay);
        }
      } else {
        displayToast.value = false;
      }
    };

    onUpdated(() => {
      updateDisplayToast();
    });

    return {
      displayToast,
      onClickClose,
    };
  },
});
</script>

<style lang="scss">
.toast {
  position: fixed;
  z-index: 999;
  left: var(--space-4);
  bottom: var(--space-4);
  background-color: var(--white);
  min-width: 10rem;
  width: 28vw;
  border-radius: 4px;
  box-shadow: 0 0.25rem 0.75rem rgba(0, 0, 0, 0.1);
  color: var(--grey-ultra-dark);

  .toast-header {
    display: flex;
    justify-content: flex-end;

    button.close {
      width: 1rem !important;
      height: 1rem !important;
      padding: 0 !important;
      color: var(--grey-medium) !important;
      background-color: transparent !important;
      border: 0 !important;
    }
  }

  .toast-body {
    padding: 0 var(--space-4) var(--space-4) var(--space-4);
    font-size: var(--font-size-14);
    line-height: 1.3;
    word-wrap: break-word;
  }

  &.success {
    background-color: var(--success-color);
    color: var(--white);

    button.close {
      color: var(--white) !important;
    }
  }
  &.error {
    background-color: var(--error-color);
    color: var(--white);

    button.close {
      color: var(--white) !important;
    }
  }
  &.warning {
    background-color: var(--warning-color);
    color: var(--white);

    button.close {
      color: var(--white) !important;
    }
  }
}
</style>
